function waitForElement(selector, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const interval = 50;
    let elapsedTime = 0;
    const checkElement = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(checkElement);
        resolve(element);
      } else if (elapsedTime >= timeout) {
        clearInterval(checkElement);
        reject(new Error(`Timeout: Element "${selector}" not found`));
      }
      elapsedTime += interval;
    }, interval);
  });
};
